var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"all"},_vm._l((_vm.personsD),function(item){return _c('el-tag',{attrs:{"type":_vm.whichType(item)},on:{"click":function($event){_vm.current=item}}},[_vm._v(_vm._s(item.name)+" "),_c('el-badge',{attrs:{"value":item.num}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }